import React from 'react';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

export default function SwitchInput(props) {

  const { label, errors, helpText, switchColumnSize, ...switchProps } = props;

  const columnSize = switchColumnSize || 12;

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl component="fieldset" error={!!errors}>
          <FormControlLabel
            control={
              <Switch {...switchProps} />
            }
            label={label}
          />
          <FormHelperText>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText} enterTouchDelay={0}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SwitchInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  helpText: PropTypes.string,
  errors: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/SwitchInput.js